(() => {
  'use strict';
  let queued = false;
  function deduplicateFamilies() {
    queued = false;
    const scopes = new Map();
    document.querySelectorAll('[data-mm-product][data-mam-pack-family]').forEach(card => {
      const wrapper = card.closest('slideshow-slide, li, .resource-list__item') || card.closest('.mm-native-card') || card;
      const scope = wrapper.parentElement;
      if (!scope) return;
      let seen = scopes.get(scope);
      if (!seen) { seen = new Set(); scopes.set(scope, seen); }
      const family = card.dataset.mamPackFamily;
      const duplicate = seen.has(family);
      seen.add(family);
      if (duplicate) {
        wrapper.dataset.mamPackDuplicate = '';
        wrapper.hidden = true;
      } else if (wrapper.hasAttribute('data-mam-pack-duplicate')) {
        delete wrapper.dataset.mamPackDuplicate;
        wrapper.hidden = false;
      }
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(deduplicateFamilies); }
  }
  function resetProductPickers() {
    document.querySelectorAll('[data-mam-product-pack-picker]').forEach(picker => {
      const select = picker.querySelector('[data-mm-variant]');
      if (select && Array.from(select.options).some(option => option.value === picker.dataset.mamCurrentVariant)) {
        select.value = picker.dataset.mamCurrentVariant;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  const popup = document.getElementById('mm-variant-popup');
  popup?.addEventListener('close', resetProductPickers);
  window.addEventListener('pageshow', resetProductPickers);
  deduplicateFamilies();
  const content = document.getElementById('MainContent');
  if (content) new MutationObserver(schedule).observe(content, { childList: true, subtree: true });
})();
